/**
 * THE FIRM — the decisions that are the firm's, not one engagement's.
 * Who is in it and what each may do (0034), and how its documents are read (ADR-0020).
 */
import { Desk, isFinanceTeam, usePrincipal } from "./shell.js";
import { Label, SERIF_OPSZ } from "../file/index.js";
import { DocumentReadingSection } from "./documentReading.js";
import { TeamSection } from "./team.js";

export function FirmScreen() {
  const finance = isFinanceTeam(usePrincipal());
  return (
    <Desk current="firm">
      <Label>Leveri</Label>
      <h1 className="mt-2 font-serif text-[32px] font-medium leading-[1.15] tracking-[-0.015em] text-ink" style={SERIF_OPSZ}>{finance ? "Your team" : "Your firm"}</h1>
      <div className="mt-6"><TeamSection /></div>
      <DocumentReadingSection />
    </Desk>
  );
}
